import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearUserData } from "../../redux/slices/userSlice";
import { clearRegisterData } from "../../redux/slices/registerSlice";
import { showManualContextualLoader } from "../../utils/contextualLoaderTrigger";
import Cookies from "js-cookie";
import { REACT_APP_NEW_JOURNEY_URL } from "../../utils/environment";

export default function Logout() {
  const dispatch = useDispatch();

  const newJourneyUrl = REACT_APP_NEW_JOURNEY_URL || "/";

  useEffect(() => {
    logout();
  }, []);

  const logout = async () => {
    showManualContextualLoader("Logging out, please wait...", 3000);

    Object.keys(Cookies.get()).forEach((name) => {
      Cookies.remove(name, { path: "/" });
    });

    localStorage.clear();

    dispatch(clearUserData());
    dispatch(clearRegisterData());

    setTimeout(() => {
      window.location.replace(newJourneyUrl);
    }, 3000);
  };

  return (
    <div>
      <img src="/images/logout.svg" style={{ opacity: 0 }} alt="" />
    </div>
  );
}
